import Vue from "vue";
import Vuex from "vuex";
import cart from "./cart/cart";
import wishlist from "./wishlist/wishlist";
import recentlyViewedProducts from "./recently-viewed-products/recently-viewed-products";

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		cart,
		"recently-viewed-products": recentlyViewedProducts,
		wishlist
	}
});
